import { findMatch } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '../../data/constants';
import findDataset from '../../state/shared';

const updateDictionaryStatusState = ({ dictionaries }, { code, status }) => {
  const dictionary = findMatch(dictionaries, code);
  dictionary.status = { ...dictionary.status, ...status };
};

const updateDictionaryStatus = withDraft((draft, { category, code, result }) => {
  const item = findDataset(draft, { category, code });
  if (item) {
    updateDictionaryStatusState(item, result);
  }
});

const updataDatasetStatus = withDraft((draft, { category, code, result }) => {
  const item = findDataset(draft, { category, code });
  if (item) {
    result.dictionaries.forEach((dictionary) => { updateDictionaryStatusState(item, dictionary); });
  }
});

export default {
  [actions.VALIDATE_DICTIONARY_DATA_SUCCESS]: updateDictionaryStatus,
  [actions.VALIDATE_DATASET_DATA_SUCCESS]: updataDatasetStatus,
};
